import React, { Component } from "react";
import { Row, Col, Card, Button, Form, Table } from "react-bootstrap";
import * as XLSX from 'xlsx';
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import AddStudentModal from "./AddStudentModal";
import SubmitAttendanceModal from './SubmitAttendanceModal';
import moment from "moment";
import HolidayModal from './holidayModal';
import AttendanceNotificationModal from './NotificationModal';
import {
    getAuthorizedBranchIds,
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
} from "../../utils/authHelper";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";
import {
    attachModuleGuard,
    AccessDeniedModal,
    AccessDeniedCard,
} from "../../../utils/moduleGuard";

// /student/attendance → "Student_Attendance".
//
// This route is NOT in MODULE_ROUTES (moduleAccessGuard), so it has no URL-level guard;
// the check below is what enforces the grant. It shares the key with its sibling
// /Employee_Attendance_Report, which MODULE_ROUTES already maps to Student_Attendance,
// and it sits in the same sidebar attendance group.
//
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
const STUDENT_ATTENDANCE_MODULE = ["Student_Attendance"];


const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const ADD_ATTENDANCE = gql`
  mutation($params: StudentAttendance) {
    addAttendance(params: $params)
  }
`;

const styles = {
    page: {
        background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
        minHeight: "100vh",
        padding: "28px 24px",
    },
    card: {
        background: "#fff",
        borderRadius: 20,
        boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
        border: "none",
        marginBottom: 24,
        overflow: "hidden",
    },
    cardHeader: {
        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
        padding: "18px 24px",
        display: "flex",
        alignItems: "center",
        gap: 10,
    },
    cardHeaderTitle: {
        color: "#fff",
        fontWeight: 700,
        fontSize: 17,
        margin: 0,
    },
    cardHeaderDot: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.6)",
    },
    cardBody: {
        padding: "22px 24px",
        minHeight: "100vh",
    },
    addBtn: {
        background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
        border: "none",
        borderRadius: 10,
        padding: "9px 20px",
        fontWeight: 700,
        fontSize: 14,
        color: "#fff",
        width: "100%",
        boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
        cursor: "pointer",
    },
    emptyState: {
        textAlign: "center",
        padding: "48px 20px",
        color: "#9ca3af",
    },
    editBtn: {
        background: "linear-gradient(135deg, #f59e0b, #d97706)",
        border: "none",
        borderRadius: 8,
        padding: "5px 14px",
        fontWeight: 600,
        fontSize: 12,
        color: "#fff",
        cursor: "pointer",
        boxShadow: "0 2px 8px rgba(245,158,11,0.3)",
    },
    saveBtn: {
        background: "linear-gradient(135deg, #10b981, #059669)",
        border: "none",
        borderRadius: 8,
        padding: "5px 14px",
        fontWeight: 600,
        fontSize: 12,
        color: "#fff",
        cursor: "pointer",
        marginRight: 6,
        boxShadow: "0 2px 8px rgba(16,185,129,0.3)",
    },
    sectionDivider: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 16,
        flexWrap: "wrap",
        gap: 12,
    },
    countChip: {
        background: "linear-gradient(135deg, #ede9fe, #dbeafe)",
        color: "#4f46e5",
        borderRadius: 20,
        padding: "4px 14px",
        fontWeight: 700,
        fontSize: 13,
        border: "1px solid #c7d2fe",
    },
    label: { fontSize: 13, fontWeight: 600, color: "#6b7280", marginBottom: 6, display: "flex", alignItems: "center", gap: 6 },
    labelIcon: { color: "#6366f1", fontSize: 13, width: 16, textAlign: "center" },
}

const ADD_HOLIDAY = gql`
  mutation($params: AddHoliday) {
    addHolidays(params: $params)
  }
`;

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
          }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
        class_id
      }
      educationalClasses {
        id
        class
      }
    }
  }
`;


// Classes that require a stream selection (e.g. Intermediate 1st/2nd year)
const STREAM_CLASS_IDS = [15, 16];
const isStreamClass = (classId) => STREAM_CLASS_IDS.includes(parseInt(classId));

class StudentAttendanceHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            BreadcrumbData: {
                Title: "STUDENT ATTENDANCE",
                btnName: "Add Student"
            },
            currentStep: 1,
            branch: "",
            section: "",
            class: "",
            exam: "",
            attendance: "",
            submitError: "",
            BranchesSection: {
                Title: "Students",
                btnName: "Add Student",
            },
            tableHeaderData: {
                Title: "Students",
            },
            attendance_status: 0,
            attendanceSearch: 0,
            yearSearchValue: "",
            attendanceSearchval: "",
            classSearch: "0",
            examSearch: "0",
            classSearchval: "",
            examSearchval: "",
            sectionSearch: "0",
            sectionSearchval: "",
            branchSearch: "0",
            branchSearchval: "",
            loadingSpinner: 0,
            classError: "",
            examError: "",
            branchError: "",
            attendanceError: "",
            sectionError: "",
            getEducationalStudents: [],
            startDateCalender: "",
            endDateCalender: "",
            modalShow: false,
            modalShow1: false,
            totalStudents: 0,
            no_of_present: 0,
            no_of_absent: 0,
            no_of_sick: 0,
            date: new Date().toISOString().slice(0, 10),
            currentDate: new Date().toISOString().slice(0, 10),
            presentAttendanceLoader: 0,
            holidayModal: false,
            notifyModal: false,
            notifyLoader: 0,
            getAbsentStudentsData: [],
            holidayBranch: "",
            holidayBranchVal: "",
            holidayBranchError: "",
            attendance_types: [],
            getExams: [],
            getClasses: [],
            getStreams: [],
            getSections: [],
            stream: "",
            streamSearchval: "",
            submitted: false,
            status: "",
            search: "",
            currentPageStartCount: 0,
            currentPageEndCount: 10,
            filterAbsenteesOnly: false,
            accessDeniedShow: false,
        };

        // Wire the module guard. Without this, this.guard is undefined and render() throws
        // ("Cannot read properties of undefined (reading 'canView')") — the page white-screens.
        this.guard = attachModuleGuard(this, STUDENT_ATTENDANCE_MODULE);
    }

    // ── Branch scope ─────────────────────────────────────────────────────────────
    // This page has no branch picker: the header multi-select (NavbarOne) decides which
    // branches are in play. The Class/Stream/Section pickers span the whole scope, so the
    // scoped branches are merged into ONE pseudo-branch whose sections carry the branch
    // they came from — every downstream helper keeps working on a single branch object,
    // and the student query can still send the right branch_id for the chosen section.
    scopedBranches = () => scopeBranches(this.props.branches || []);

    scopedBranchData = () => {
        const scoped = this.scopedBranches();
        if (scoped.length === 0) return null;
        return {
            id: scoped[0].id,
            branch_name: scoped[0].branch_name,
            multiBranch: scoped.length > 1,
            sections: scoped.flatMap((b) =>
                (b.sections || []).map((s) => ({ ...s, branch_id: b.id, branch_name: b.branch_name }))
            ),
        };
    };

    // branch_id for the section currently picked — its own branch, not the first in scope.
    selectedSectionBranchId = () => {
        const secId = this.state.sectionSearchval?.value;
        const merged = this.scopedBranchData();
        const sec = (merged?.sections || []).find((s) => +s.id === +secId);
        return sec ? sec.branch_id : merged?.id;
    };

    // ── Stream helpers: stream only narrows sections (sections carry stream_id) ──
    buildStreamOptions = (branchData, classId) => {
        if (!isStreamClass(classId)) return [];
        const streamIds = [...new Set(
            (branchData?.sections || [])
                .filter(s => +s.class_id === +classId && s.stream_id)
                .map(s => String(s.stream_id))
        )];
        return streamIds
            .map(sid => {
                const st = (this.props.streams || []).find(x => +x.id === +sid);
                return st ? { value: st.id, label: st.stream } : null;
            })
            .filter(Boolean);
    };

    buildSectionOptions = (branchData, classId, streamVal) => {
        if (!branchData) return [];
        const authSecIds = getAuthorizedSectionIds();
        const authClassIds = getAuthorizedClassIds();

        return this.sortSectionsByClassThenLabel(
            (branchData.sections || [])
                .filter(s => +s.class_id === +classId)
                .filter(s => !isStreamClass(classId) || +s.stream_id === +streamVal)
                .filter(s => {
                    if (authSecIds.length > 0 && !authSecIds.includes(String(s.id))) return false;
                    if (authClassIds.length > 0 && !authClassIds.includes(String(s.class_id))) return false;
                    return true;
                })
                // Section names repeat across branches, so qualify them once the header
                // has more than one branch in scope.
                .map(s => ({
                    value: s.id,
                    label: branchData.multiBranch && s.branch_name
                        ? `${s.section_name} (${s.branch_name})`
                        : s.section_name,
                    class_id: s.class_id,
                    branch_id: s.branch_id,
                }))
        );
    };

    sortByLabelAsc = (items) =>
        [...items].sort((a, b) =>
            String(a.value ?? "").localeCompare(String(b.value ?? ""), undefined, { sensitivity: "base", numeric: true })
        );

    sortSectionsByClassThenLabel = (items) =>
        [...items].sort((a, b) => {
            const byClass = String(a.class_id ?? "").localeCompare(String(b.class_id ?? ""), undefined, { numeric: true });
            if (byClass !== 0) return byClass;
            return String(a.value ?? "").localeCompare(String(b.value ?? ""), undefined, { sensitivity: "base", numeric: true });
        });

    componentDidMount() {
        // is_view === 0 → don't fetch anything. getAttendanceTypes below is an imperative
        // client.query(), which the `skip` on the parent's HOCs doesn't cover.
        if (!this.guard.canView()) return;

        this.initFromBranchScope();
        // Branch comes from the header (NavbarOne) — re-seed the pickers when it changes.
        this.offBranchScope = onBranchScopeChange(() => this.initFromBranchScope());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    // Seed Year/Class/Stream/Section from the header's branch scope.
    initFromBranchScope = () => {
        const { academicYears } = this.props;

        // Every branch the header has in scope, merged into one pseudo-branch.
        const branchSearchData = this.scopedBranchData();

        this.getAttendanceTypes(branchSearchData?.id);

        const allClasses =
            this.props.classes || [];

        // Class Array
        const classArr = branchSearchData
            ? [...new Set(
                branchSearchData.sections.map(
                    (s) => s.class_id
                )
            )]
                .map((classId) => {

                    const classData =
                        allClasses.find(
                            (c) => +c.id === +classId
                        );

                    return classData
                        ? {
                            value: classData.id,
                            label: classData.class
                        }
                        : null;

                })
                .filter(Boolean)
            : [];
        const sortedClassArr = this.sortByLabelAsc(classArr);

        // Selected Class
        const selectedClass =
            sortedClassArr?.length > 0
                ? sortedClassArr[0]
                : null;

        // Stream Array (only for stream classes) + auto-select first
        const streamArr = selectedClass
            ? this.buildStreamOptions(branchSearchData, selectedClass.value)
            : [];
        const selectedStream =
            streamArr?.length > 0
                ? streamArr[0]
                : null;

        // Section Array (narrowed by stream for stream classes)
        const sectionArr = (branchSearchData && selectedClass)
            ? this.buildSectionOptions(branchSearchData, selectedClass.value, selectedStream?.value)
            : [];

        // Selected Section
        const selectedSection =
            sectionArr?.length > 0
                ? sectionArr[0]
                : null;

        this.setState({

            getStreams: streamArr,

            streamSearchval: selectedStream
                ? { value: selectedStream.value, label: selectedStream.label }
                : "",

            stream: selectedStream?.label || "",

            yearSearchValue:
                academicYears?.length > 0
                    ? {
                        value: academicYears[0].id,
                        label:
                            academicYears[0]
                                .academic_year
                    }
                    : "",

            // Mirrors the header scope; there is no branch picker on this page.
            branchSearchval:
                branchSearchData
                    ? {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    }
                    : "",

            getClasses: sortedClassArr,

            classSearchval:
                selectedClass
                    ? {
                        value:
                            selectedClass.value,
                        label:
                            selectedClass.label
                    }
                    : "",

            getSections: sectionArr,

            sectionSearchval:
                selectedSection
                    ? {
                        value:
                            selectedSection.value,
                        label:
                            selectedSection.label
                    }
                    : "",

            section:
                selectedSection?.label || "",
        });
    }

    submit = () => {
        this.setState({
            getEducationalStudents: [],
            classSearchval: {
                value: "0",
                label: "Select"
            },
            class: "",
            examSearchval: {
                value: "0",
                label: "Select"
            },
            yearSearchValue: {
                value: "0",
                label: "Select"
            },
            exam: "",
            streamSearchval: {
                value: "0",
                label: "Select"
            },
            stream: "",
            sectionSearchval: {
                value: "0",
                label: "Select"
            },
            section: "",
            branchSearchval: {
                value: "0",
                label: "Select"
            },
            branch: "",
            attendanceSearchval: {
                value: "0",
                label: "Select"
            },
            attendance: "",
            date: new Date().toISOString().slice(0, 10),
        })
    }

    selecthandleInputChange = (ename, evalue) => {
        const name = ename;
        const value = evalue;
        let getArray = [];

        if (name === "yearSearch") {
            let yearSearchData = this.props.academicYears.find((a) => a.id == value);
            this.getAttendanceTypes(355);
            if (value !== "0") {
                this.setState({
                    yearSearchValue: {
                        value: yearSearchData.id,
                        label: yearSearchData.academic_year
                    },
                    yearError: "",
                    branch: "",
                    branchSearchval: "",
                    class: "",
                    classError: "",
                    classSearchval: "",
                    section: "",
                    sectionError: "",
                    sectionSearchval: "",
                    getClasses: [],
                    getSections: [],
                    is_submitted: false,
                    attendanceSearchval: "",
                });

            } else {
                this.setState({
                    yearSearchValue: {
                        value: "0",
                        label: "Select"
                    },
                    yearError: "",
                    branch: "",
                    branchSearchval: "",
                    class: "",
                    classError: "",
                    classSearchval: "",
                    section: "",
                    sectionError: "",
                    sectionSearchval: "",
                    getClasses: [],
                    getSections: [],
                    is_submitted: false,
                    attendanceSearchval: "",
                });
            }
        }

        // No //branch case — the header (NavbarOne) owns branch selection now.

        //class
        if (name == "classSearch") {
            this.getAttendanceTypes(+this.state.branchSearchval?.value);
            if (value != "0") {
                const classSearchData =
                    this.props.classes.find(
                        (a) => +a.id === +value
                    );

                // Options span every branch the header has in scope.
                const selectedBranchData = this.scopedBranchData();

                // Stream Array (only for stream classes) + auto-select first
                const streamArr = this.buildStreamOptions(selectedBranchData, value);
                const selectedStream =
                    streamArr.length > 0
                        ? streamArr[0]
                        : null;

                // Section Array based on class (narrowed by stream for stream classes)
                const sectionArr = this.buildSectionOptions(selectedBranchData, value, selectedStream?.value);

                this.setState({
                    classSearchval: {
                        value: classSearchData.id,
                        label: classSearchData.class
                    },
                    class: classSearchData.class,
                    classError: "",
                    getEducationalStudents: [],
                    attendance_types: [],
                    attendance: "",
                    getStreams: streamArr,
                    streamSearchval:
                        selectedStream
                            ? { value: selectedStream.value, label: selectedStream.label }
                            : "",
                    stream: selectedStream?.label || "",
                    section: "",
                    sectionSearchval: "",
                    attendanceSearchval: "",
                    attendance_types: [],
                    getSections: sectionArr.map((individualSectionData) => ({
                        value: individualSectionData.value,
                        label: individualSectionData.label
                    })),
                    attendanceError: "",
                    sectionError: "",
                    submitted: false,
                    search: "",
                });
            } else {
                this.setState({
                    classSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    getEducationalStudents: [],
                    attendance_types: [],
                    attendanceSearchval: "",
                    attendance: "",
                    class: "",
                    section: "",
                    classSearchval: "",
                    streamSearchval: "",
                    stream: "",
                    sectionSearchval: "",
                    attendance_types: [],
                    getClasses: [],
                    getStreams: [],
                    getSections: [],
                    classError: "",
                    attendanceError: "",
                    sectionError: "",
                    submitted: false,
                    search: "",

                });
            }
        }

        //stream — only narrows sections, no backend filter (sections carry stream_id)
        if (name == "streamSearch") {
            const selectedBranchData = this.scopedBranchData();
            const classVal = this.state.classSearchval?.value;
            if (value != "0") {
                const streamData = (this.state.getStreams || []).find(
                    (s) => +s.value === +value
                );
                const sectionArr = this.buildSectionOptions(selectedBranchData, classVal, value);
                this.setState({
                    streamSearchval: streamData
                        ? { value: streamData.value, label: streamData.label }
                        : "",
                    stream: streamData?.label || "",
                    getSections: sectionArr.map((s) => ({ value: s.value, label: s.label })),
                    section: "",
                    sectionSearchval: "",
                    getEducationalStudents: [],
                    attendance_types: [],
                    attendanceSearchval: "",
                    sectionError: "",
                    submitted: false,
                    search: "",
                });
            } else {
                this.setState({
                    streamSearchval: { value: "0", label: "Select" },
                    stream: "",
                    getSections: [],
                    section: "",
                    sectionSearchval: "",
                    getEducationalStudents: [],
                    sectionError: "",
                    submitted: false,
                    search: "",
                });
            }
        }

        if (name == "sectionSearch") {
            this.getAttendanceTypes(+this.state.branchSearchval?.value);
            if (value != "0") {

                const selectedBranchData = this.scopedBranchData();

                // Selected Class
                const selectedClass =
                    this.state.classSearchval?.value
                        ? [+this.state.classSearchval.value]
                        : [];

                // Section Array
                const sectionArr = selectedBranchData
                    ? selectedBranchData.sections
                        .filter(
                            (s) =>
                                selectedClass.length === 0 ||
                                selectedClass.includes(s.class_id)
                        )
                        .map((s) => ({
                            value: s.id,
                            label: s.section_name,
                            class_id: s.class_id,
                        }))
                    : [];

                // Selected Section
                const sectionSearchData =
                    sectionArr.find(
                        (s) => +s.value === +value
                    );

                this.setState({
                    sectionSearchval: {
                        value: sectionSearchData.value,
                        label: sectionSearchData.label
                    },
                    section: sectionSearchData.label,
                    sectionError: "",
                    getEducationalStudents: [],
                    submitted: false,
                    search: "",
                    attendanceSearchval: "",
                });
            } else {
                this.setState({
                    sectionSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    section: "",
                    sectionError: "",
                    getEducationalStudents: [],
                    attendanceError: "",
                    attendanceSearchval: "",
                    attendance_types: [],
                    submitted: false,
                    search: "",
                });
            }
        }

        if (name == "holidayBranch") {
            console.log("values", value, name);
            if (value != "0") {
                let branchSearchData = this.props.branches.find((a) => a.id == value);
                console.log("brrrrr", branchSearchData);
                this.setState({
                    holidayBranchVal: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                    holidayBranch: value,
                    holidayBranchError: "",
                });
            } else {
                this.setState({
                    holidayBranchVal: {
                        value: "0",
                        label: "Select"
                    },
                    holidayBranch: "",
                });
            }
        }

        //attendance Types
        if (name == "attendanceType") {
            let attendanceSearchData = this.state.attendance_types.find((a) => a.value == value);
            console.log("this.state.attendance_types", attendanceSearchData);
            this.setState({
                attendanceSearchval: {
                    value: attendanceSearchData.value,
                    label: attendanceSearchData.label
                },
                attendance: attendanceSearchData.attendance_subtype,
                attendanceError: "",
                getEducationalStudents: [],
                submitted: false,
                search: "",
            });
        }
        this.setState({ [name]: value });
    }



    getAttendanceTypes = async (val) => {
        const result = await this.props.client.query({
            query: gql` 
           query($institution_id: Int,$branch_id:Int
               ) {
                getAttendanceTypes(institution_id: $institution_id,branch_id:$branch_id) {
                    id
                    attendance_subtype
                }
           }
       `,
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val)
            },
            fetchPolicy: 'network-only'
        });

        if (result.data.getAttendanceTypes != undefined) {
            let data = [];
            result.data.getAttendanceTypes.map((item) => {
                data.push({ value: item.id, label: item.attendance_subtype })
            })
            this.setState({
                attendance_types: this.sortByLabelAsc(data)
            });
        }
    };

    handleFormSubmit = e => {

        if (this.state.yearSearchValue === "") {
            // this.setState({ branchError: "Please select branch" });
            // return ""
            return;
        }

        if (this.state.branchSearchval === "") {
            // this.setState({ examError: "Please select exam" });
            // return ""
            return;
        }

        if (this.state.classSearchval === "") {
            // this.setState({ classError: "Please select class" });
            // return ""

            return;
        }



        if (this.state.sectionSearchval === "") {
            // this.setState({ sectionError: "Please select section" });
            // return ""

            return;
        }


        if (this.state.attendanceSearchval === "") {
            // this.setState({ attendanceError: "Please select attendance Type" });
            // return ""

            return;
        }

        e.preventDefault();

        this.setState({
            loader: 1
        });

        this.getEducationalStudents();
    };

    getEducationalStudents = async () => {
        const result = await this.props.client.query({
            query: gql` 
           query(
            $institution_id: Int!,$class_id:Int,$section_id:Int,$branch_id:Int,$type_id:Int,$selected_date:String
               ) {
                getEducationalStudents(institution_id: $institution_id,section_id:$section_id,branch_id:$branch_id,class_id:$class_id,type_id:$type_id,selected_date:$selected_date) {
                    id
                    student_name
                    student_mobile
                    roll_no
                    father_name
                    mother_name
                    dob
                    mother_phone
                    exam_id
                    class_id
                    branch_id
                    section_id
                    attendance_status  
                    father_phone
               }
           }
       `,
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                // The chosen section's own branch — sections can span branches in scope.
                branch_id: parseInt(this.selectedSectionBranchId()),
                class_id: parseInt(this.state.classSearchval.value),
                section_id: parseInt(this.state.sectionSearchval.value),
                type_id: parseInt(this.state.attendanceSearchval.value),
                selected_date: moment(this.state.date, 'YYYY-MM-DD').unix().toString()
            },
            fetchPolicy: 'network-only'
        });

        if (result.data.getEducationalStudents != undefined) {
            let data = [];
            result.data.getEducationalStudents.sort((a, b) => a.attendance_status - b.attendance_status).map((item) => {
                let label = "Present";
                const statusVal = parseInt(item.attendance_status);
                if (statusVal === 1) {
                    label = "Present"
                } else if (statusVal === 0) {
                    label = "Absent"
                } else if (statusVal === 3) {
                    label = "Sick"
                }
                data.push({ ...item, value: isNaN(statusVal) ? 1 : statusVal, label })
            });

            let totalStudents = data.length;
            let no_of_present = data.filter((item) => parseInt(item.value) == 1).length;
            let no_of_absent = data.filter((item) => parseInt(item.value) == 0).length;
            let no_of_sick = data.filter((item) => parseInt(item.value) == 3).length;

            this.setState({
                getEducationalStudents: data,
                loader: 0,
                totalStudents: totalStudents,
                no_of_present: no_of_present,
                no_of_absent,
                no_of_sick,
                submitted: true,
                currentPageStartCount: 0,
                currentPageEndCount: 10,
                search: "",
            });
        }
    };

    tableData = (savedPapersData) => {
        let getArray = [];

        savedPapersData.map(item => {
            let class_name = "";
            let branch_name = "";
            let exam_name = "";
            let section_name = "";

            this.props.classes.map((stumap) => {
                if (stumap.id == item.class_id) {
                    class_name = stumap.class
                }
            });

            this.props.branches.map((stumap) => {
                if (stumap.id == item.branch_id) {
                    branch_name = stumap.branch_name
                }
            });

            // this.props.globals.globals.exams.map((stumap) => {
            //     if (stumap.id == item.exam_id) {
            //         exam_name = stumap.exam
            //     }
            // });

            this.props.branches.flatMap(b => b.sections).map((stumap1) => {
                if (stumap1.id == item.section_id) {
                    section_name = stumap1.section_name
                }
            })

            const newObject = {
                id: item.id,
                student_name: item.student_name,
                student_rollno: item.roll_no,
                student_mobile: item.student_mobile,
                class_name: class_name,
                branch_name: branch_name,
                exam_name: exam_name,
                section_name: section_name,
                attendance_status: item.attendance_status
            }
            getArray.push(newObject);
        })

        return getArray;
    }

    presentOrAbsent = (e, row) => {

        let educationalStudents = [];

        educationalStudents = this.state.getEducationalStudents.map((item) => {
            if (item.id == row.id) {
                if (e.target.value == 1) {
                    return { ...item, value: 1, label: "Present" }
                }
                else if (e.target.value == 0) {
                    return { ...item, value: 0, label: "Absent" }
                }
                else {
                    return { ...item, value: 3, label: "Sick" }
                }
            } else {
                return { ...item }
            }
        })


        let totalStudents = this.state.getEducationalStudents.length;
        let no_of_present = educationalStudents.filter((item) => item.value == 1).length;
        let no_of_absent = educationalStudents.filter((item) => item.value == 0).length;
        let no_of_sick = educationalStudents.filter((item) => item.value == 3).length;

        this.setState({ getEducationalStudents: educationalStudents, totalStudents: totalStudents, no_of_present: no_of_present, no_of_absent, no_of_sick });

    }

    changeAttendance = (value, row) => {
        const labelMap = { 1: "Present", 0: "Absent", 3: "Sick" };
        const educationalStudents = this.state.getEducationalStudents.map((item) =>
            item.id === row.id
                ? { ...item, value, label: labelMap[value] }
                : { ...item }
        );
        const no_of_present = educationalStudents.filter((item) => item.value == 1).length;
        const no_of_absent = educationalStudents.filter((item) => item.value == 0).length;
        const no_of_sick = educationalStudents.filter((item) => item.value == 3).length;
        this.setState({
            getEducationalStudents: educationalStudents,
            totalStudents: educationalStudents.length,
            no_of_present,
            no_of_absent,
            no_of_sick,
        });
    }

    present = (row, rowIndex, formatExtraData) => {
        let attendance_status = this.sortByLabelAsc([
            { value: 1, label: "Present" },
            { value: 0, label: "Absent" },
        ]);
        let attendedStatus = this.state.getEducationalStudents.filter((item) => item.id == row.id)
        console.log("attendedStatus", attendedStatus);
        return (
            <>
                <select class="form-control" onChange={(e) => { this.presentOrAbsent(e, row) }}>
                    {
                        attendance_status.map((item) => {
                            if (item.value == attendedStatus[0].value) {
                                return <option value={item.value} selected >{item.label}</option>
                            } else {
                                return <option value={item.value}>{item.label}</option>
                            }
                        })
                    }
                </select>
            </>
        )
    }

    articlecolumns = [
        {
            dataField: "student_rollno",
            text: "Student Roll no",
        },
        {
            dataField: "student_name",
            text: "Student Name",
        },
        {
            dataField: "student_mobile",
            text: "Student Mobile",
        },
        {
            dataField: "branch_name",
            text: "Branch",
        },
        {
            dataField: "exam_name",
            text: "Exam",
        },
        {
            dataField: "class_name",
            text: "Class",
        },
        {
            dataField: "section_name",
            text: "Section",
        },
        {
            dataField: "attendance_status",
            text: "Attendance Status",
            formatter: this.present.bind(this)
        },

    ];

    applyCallback = (startDate, endDate) => {
        this.setState({
            startDateCalender: startDate.unix(),
            endDateCalender: endDate.unix()
        })
    }

    selDate = (e) => {
        this.setState({ date: e.target.value, getEducationalStudents: [], submitted: false })
    }

    // Submitting attendance writes to the server → is_edit. Gated before the modal opens,
    // same as the other write actions on this page. (This handler was referenced by the
    // Submit Attendance button but never defined, so onClick was undefined and the button
    // silently did nothing.)
    openSubmitAttendanceModal = () => {
        if (!this.guard.requireEdit()) return;

        this.setState({ modalShow1: true });
    }

    // Marking a holiday writes to the server → is_edit. Gated before the modal opens.
    openHolidayModal = () => {
        if (!this.guard.requireEdit()) return;

        this.setState({ holidayModal: true })
    }

    markHoliday = async () => {
        // Re-checked at submit, not only when the modal opened: the modal could already
        // be open when a grant changes. Ahead of the branch validation, so a role without
        // is_edit is told they lack access rather than being sent to fix the form.
        if (!this.guard.requireEdit()) {
            this.setState({ holidayModal: false });
            return;
        }

        if (this.state.holidayBranch == "" || this.state.holidayBranch == "0") {
            this.setState({
                holidayBranchError
                    :
                    "Please Select Branch"
            });
            return ""
        }

        let params = {
            holiday_date: moment(this.state.date, 'YYYY-MM-DD').unix().toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.holidayBranch)
        }

        this.addHolidays(params).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
            setTimeout(() => {
                this.SetpageLoad();

            }, 2000);
        })
    }

    // Last gate before the ADD_HOLIDAY mutation leaves the client.
    addHolidays = async params => {
        if (!this.guard.requireEdit()) return;

        await this.props.addHolidays({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addHolidays) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });

                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0, holidayModal: false });
        if (this.props.history) {
            this.props.history.push("/student/attendance-report");
        } else {
            window.location.href = "/student/attendance-report";
        }
    };

    // Opens the absentee-notification modal, whose child SENDS notifications to parents.
    // Sending is a write → is_edit, so the opener is gated (the query it runs to list
    // absentees is only a read, but it exists solely to feed that send).
    openSendNotificationModal = async () => {
        if (!this.guard.requireEdit()) return;

        this.setState({ notifyModal: true, notifyLoader: 1 })

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$date:String $section_id:Int,$attendance_subtype_id:Int){
                getAbsentStudentsData(institute_id:$institute_id,branch_id:$branch_id,date:$date ,section_id:$section_id,attendance_subtype_id:$attendance_subtype_id){
                    student_name
                    parent_mobile
                  }
            }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                // The chosen section's own branch — sections can span branches in scope.
                branch_id: parseInt(this.selectedSectionBranchId()),
                section_id: parseInt(this.state.sectionSearchval.value),
                date: moment(this.state.date, 'YYYY-MM-DD').unix().toString(),
                attendance_subtype_id: parseInt(this.state.attendanceSearchval.value)
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getAbsentStudentsData.length > 0) {
            this.setState({
                getAbsentStudentsData: result.data.getAbsentStudentsData,
                notifyLoader: 0
            });

        } else {
            this.setState({
                getAbsentStudentsData: [],
                notifyLoader: 0
            })
        }
    }

    searchFilter = (e) => {
        let value = e.target.value
        console.log("e", value);
        this.setState({ search: value, currentPageStartCount: 0, currentPageEndCount: 10 })
    }


    pageChange = (pageNumber) => {
        console.log("pageNumber", pageNumber);
        this.setState({
            currentPageStartCount: (+pageNumber - 1) * 10,
            currentPageEndCount: +pageNumber * 10
        })
    }

    clearAttendanceData = () => {
        this.setState({ getEducationalStudents: [], submitted: false })
    }

    downloadExcel = () => {
        const students = this.state.getEducationalStudents;

        const data = students.map((item, index) => {
            let class_name = "";
            let section_name = "";

            this.props.classes.forEach((c) => {
                if (c.id == item.class_id) class_name = c.class;
            });

            this.props.branches.flatMap(b => b.sections).forEach((s) => {
                if (s.id == item.section_id) section_name = s.section_name;
            });

            return {
                "Sno": index + 1,
                "Roll No": item.roll_no,
                "Student Name": item.student_name,
                "Mobile": item.student_mobile,
                "Class": class_name,
                "Section": section_name,
                "Attendance Status": item.value == 1 ? "Present" : item.value == 0 ? "Absent" : "Sick"
            };
        });

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Attendance");

        const branch = this.state.branchSearchval?.label || "Branch";
        const section = this.state.sectionSearchval?.label || "Section";
        const date = this.state.date;

        XLSX.writeFile(wb, `Attendance_${branch}_${section}_${date}.xlsx`);
    };

    printStudentDetails = () => {
        const students = this.state.getEducationalStudents;

        const rows = students.map((item, index) => {
            let class_name = "";
            let section_name = "";

            this.props.classes.forEach((c) => {
                if (c.id == item.class_id) class_name = c.class;
            });

            this.props.branches.flatMap(b => b.sections).forEach((s) => {
                if (s.id == item.section_id) section_name = s.section_name;
            });

            const status = item.value == 1 ? "Present" : item.value == 0 ? "Absent" : "Sick";
            const statusColor = item.value == 1 ? "#16a34a" : item.value == 0 ? "#dc2626" : "#d97706";

            return `<tr>
                <td>${index + 1}</td>
                <td>${item.roll_no}</td>
                <td>${item.student_name}</td>
                <td>${item.student_mobile}</td>
                <td>${class_name}</td>
                <td>${section_name}</td>
                <td style="color:${statusColor};font-weight:600">${status}</td>
            </tr>`;
        }).join("");

        const branch = this.state.branchSearchval?.label || "";
        const section = this.state.sectionSearchval?.label || "";
        const date = this.state.date;

        const printContent = `
            <html>
            <head>
                <title>Student Attendance</title>
                <style>
                    body { font-family: Arial, sans-serif; padding: 20px; }
                    h2 { text-align: center; color: #4f46e5; margin-bottom: 4px; }
                    .meta { text-align: center; color: #6b7280; margin: 4px 0 20px 0; font-size: 13px; }
                    table { width: 100%; border-collapse: collapse; }
                    th { background: #4f46e5; color: #fff; padding: 10px 12px; text-align: left; font-size: 13px; }
                    td { padding: 10px 12px; border-bottom: 1px solid #e5e7eb; font-size: 13px; }
                    tr:nth-child(even) td { background: #f9fafb; }
                    @media print { body { padding: 0; } }
                </style>
            </head>
            <body>
                <h2>Student Attendance Report</h2>
                <p class="meta">Branch: <strong>${branch}</strong> &nbsp;|&nbsp; Section: <strong>${section}</strong> &nbsp;|&nbsp; Date: <strong>${date}</strong></p>
                <table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Roll No</th>
                            <th>Student Name</th>
                            <th>Mobile</th>
                            <th>Class</th>
                            <th>Section</th>
                            <th>Attendance Status</th>
                        </tr>
                    </thead>
                    <tbody>${rows}</tbody>
                </table>
            </body>
            </html>
        `;

        const printWindow = window.open("", "_blank");
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };


    submitPresentAndAbsentAttendance = (type) => {
        const newValue = type === "present" ? 1 : 0;
        const label = type === "present" ? "Present" : "Absent";

        const updatedStudents = this.state.getEducationalStudents.map((item) => ({
            ...item,
            value: newValue,
            label: label
        }));

        const totalStudents = updatedStudents.length;
        const no_of_present = updatedStudents.filter((item) => item.value == 1).length;
        const no_of_absent = updatedStudents.filter((item) => item.value == 0).length;
        const no_of_sick = updatedStudents.filter((item) => item.value == 3).length;

        this.setState({
            getEducationalStudents: updatedStudents,
            totalStudents,
            no_of_present,
            no_of_absent,
            no_of_sick
        });
    };

    render() {
        // is_view === 0 → the attendance data is never rendered, componentDidMount bails
        // before fetching, and the parent's four queries are skipped. `embedded` keeps the
        // padding consistent when this is mounted inside another page's modal.
        if (!this.guard.canView()) {
            return (
                <div style={this.props.embedded ? { padding: 0 } : styles.page}>
                    <AccessDeniedCard />
                </div>
            );
        }

        // const globals = this.props.globals;
        // const loading1 = globals.loading;
        // const error1 = globals.error;

        console.log("fff", this.state.getEducationalStudents);

        let filterStudentData = this.state.getEducationalStudents;

        if (this.state.search != "") {
            filterStudentData = this.state.getEducationalStudents.filter((item) => item.student_mobile.includes(this.state.search) || item.student_name.toLowerCase().includes(this.state.search.toLocaleLowerCase()) || item.roll_no.includes(this.state.search))
        }

        console.log("this.state.branchSearch", this.state.branchSearch);

        // if (loading1) {
        //     return (
        //         <Container>
        //             <Row>
        //                 <Col sm={12}>
        //                     <div className="spinner-border  text-center loading-img-center"></div>
        //                 </Col >
        //             </Row>
        //         </Container >
        //     )
        // }

        // if (error1 !== undefined) {
        //     alert("Server Error. " + error1.message);
        //     return null;
        // }



        let startNumber = 0
        let endNumber = filterStudentData.length;

        let pages = Math.ceil(endNumber / 10);

        let pagewiseFilterData = filterStudentData.filter((item, index) => index >= this.state.currentPageStartCount && index < this.state.currentPageEndCount);


        const headerStyle = {
            color: "#000",
            padding: "16px",
            fontSize: "14px",
            fontWeight: "600",
            whiteSpace: "nowrap",
            border: "1px solid #e5e7eb",
            background: "rgba(250, 251, 255, 1)",
            textAlign: "center",
        };

        const bodyStyle = {
            padding: "16px",
            verticalAlign: "middle",
            fontSize: "14px",
            color: "#374151",
            whiteSpace: "nowrap",
            border: "1px solid #e5e7eb",
            textAlign: "center",
        };

        const columns = [
            {
                dataField: "sno",
                text: "Sno",
                headerStyle: headerStyle,
                style: bodyStyle,
                formatter: (cell, row, rowIndex) => rowIndex + 1
            },
            {
                dataField: "roll_no",
                text: "Roll No",
                sort: true,
                headerStyle: headerStyle,
                style: bodyStyle,
                formatter: (cell, row) => row.roll_no ?? "-"
            },
            {
                dataField: "student_name",
                text: "Student Name",
                sort: true,
                headerStyle: headerStyle,
                style: bodyStyle,
                formatter: (cell, row) => {
                    const isModified = isNaN(parseInt(row.attendance_status))
                        ? (parseInt(row.value) !== 1)
                        : (parseInt(row.value) !== parseInt(row.attendance_status));
                    return (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                            <span>{row.student_name ?? "-"}</span>
                            {isModified && (
                                <span style={{
                                    fontSize: "10px",
                                    background: "#e0f2fe",
                                    color: "#0369a1",
                                    padding: "2px 6px",
                                    borderRadius: "4px",
                                    fontWeight: "600"
                                }}>
                                    Modified
                                </span>
                            )}
                        </div>
                    );
                }
            },
            // {
            //     dataField: "student_mobile",
            //     text: "Student Mobile",
            //     headerStyle: headerStyle,
            //     style: bodyStyle,
            //     formatter: (cell, row) => row.student_mobile ?? "-"
            // },
            {
                dataField: "father_name",
                text: "Father Name",
                headerStyle: headerStyle,
                style: bodyStyle,
                formatter: (cell, row) => row.father_name ?? "-"
            },
            // {
            //     dataField: "father_phone",
            //     text: "Father Mobile",
            //     headerStyle: headerStyle,
            //     style: bodyStyle,
            //     formatter: (cell, row) => row.father_phone ?? "-"
            // },
            // {
            //     dataField: "mother_name",
            //     text: "Mother Name",
            //     headerStyle: headerStyle,
            //     style: bodyStyle,
            //     formatter: (cell, row) => row.mother_name ?? "-"
            // },
            // {
            //     dataField: "dob",
            //     text: "DOB",
            //     headerStyle: headerStyle,
            //     style: bodyStyle,
            //     formatter: (cell, row) => row.dob ?? "-"
            // },
            {
                dataField: "branch_id",
                text: "Branch",
                headerStyle: headerStyle,
                style: bodyStyle,
                formatter: (cell, row) => {
                    const branchObj = this.props.branches.find((b) => b.id == row.branch_id);
                    return branchObj ? branchObj.branch_name : "-";
                }
            },
            {
                dataField: "class_id",
                text: "Class",
                headerStyle: headerStyle,
                style: bodyStyle,
                formatter: (cell, row) => {
                    const classObj = this.props.classes.find((c) => c.id == row.class_id);
                    return classObj ? classObj.class : "-";
                }
            },
            {
                dataField: "section_id",
                text: "Section",
                headerStyle: headerStyle,
                style: bodyStyle,
                formatter: (cell, row) => {
                    const sectionObj = this.props.branches.flatMap(b => b.sections).find((s) => s.id == row.section_id);
                    return sectionObj ? sectionObj.section_name : "-";
                }
            },
            {
                dataField: "attendance_status",
                text: "Attendance",
                headerStyle: headerStyle,
                style: bodyStyle,
                formatter: (cell, row) => {
                    return (
                        <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                            <button
                                onClick={() => this.presentOrAbsent({ target: { value: 1 } }, row)}
                                style={{
                                    borderRadius: "8px",
                                    padding: "6px 14px",
                                    fontWeight: "700",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                    border: row.value === 1 ? "2px solid #16a34a" : "1px solid #d1d5db",
                                    background: row.value === 1 ? "#dcfce7" : "#fff",
                                    color: row.value === 1 ? "#15803d" : "#4b5563",
                                }}
                            >
                                P
                            </button>
                            <button
                                onClick={() => this.presentOrAbsent({ target: { value: 0 } }, row)}
                                style={{
                                    borderRadius: "8px",
                                    padding: "6px 14px",
                                    fontWeight: "700",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                    border: row.value === 0 ? "2px solid #dc2626" : "1px solid #d1d5db",
                                    background: row.value === 0 ? "#fee2e2" : "#fff",
                                    color: row.value === 0 ? "#b91c1c" : "#4b5563",
                                }}
                            >
                                A
                            </button>
                        </div>
                    );
                }
            }
        ];

        return (
            <div style={this.props.embedded ? { padding: 0 } : styles.page}>
                {/* Top Section */}
                <div style={this.props.embedded ? { ...styles.card, marginBottom: 0, boxShadow: "none", overflow: "visible" } : styles.card}>
                    {/* <div style={styles.cardHeader}>
                        <div style={styles.cardHeaderDot}></div>
                        <h5 style={styles.cardHeaderTitle}>STUDENT ATTENDANCE</h5>
                    </div> */}

                    <div style={styles.cardBody}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 10 }}>
                            <h4 style={{ margin: 0, fontWeight: 700, color: "#1e293b", fontSize: "18px" }}>Student Attendance Marking</h4>
                            <Button
                                name="backToReport"
                                variant="light"
                                onClick={() => this.props.history.push("/attendance-regularization")}
                                style={{
                                    border: "1px solid #dbeafe",
                                    background: "#fff",
                                    color: "#4f46e5",
                                    fontWeight: "700",
                                    borderRadius: "10px",
                                    padding: "8px 16px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    boxShadow: "0 2px 6px rgba(99,102,241,0.08)",
                                    fontSize: "13px"
                                }}
                            >
                                <i className="fas fa-arrow-left"></i> Back to Report
                            </Button>
                        </div>
                        <Row className="justify-content-between align-items-center">

                            {/* RIGHT SECTION */}
                            <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="mb-3 d-flex justify-content-md-end"
                            >

                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: 18,
                                        padding: 18,
                                        width: "100%",
                                        boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
                                        border: "1px solid #eef2ff",
                                    }}
                                >

                                    {/* HEADER */}
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            marginBottom: 15,
                                        }}
                                    >

                                        <h6
                                            style={{
                                                margin: 0,
                                                fontWeight: 700,
                                                color: "#374151",
                                                fontSize: 15,
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                        >
                                            <i className="far fa-calendar-alt mr-2" style={{ color: "#6366f1" }}></i>
                                            Select Date
                                        </h6>
                                    </div>
                                    <input
                                        type="date"
                                        value={this.state.date}
                                        onChange={this.selDate}
                                        max={new Date().toISOString().split("T")[0]}
                                        style={{
                                            width: "100%",
                                            padding: "8px 12px",
                                            border: "1.5px solid #e2e8f0",
                                            borderRadius: "10px",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "#334155",
                                            outline: "none",
                                            backgroundColor: "#f8fafc",
                                            transition: "border-color 0.2s"
                                        }}
                                    />
                                </div>

                            </Col>

                        </Row>

                        <Row>
                            <Col lg={2} md={12} sm={12}>
                                <div style={styles.label}><i className="far fa-calendar-check" style={styles.labelIcon} />Select Year</div>
                                <SelectDropDown
                                    stateData={this.state.yearSearchValue}
                                    handleChange={this.selecthandleInputChange}
                                    name="yearSearch"
                                    options={(this.props.academicYears).map((item) => ({
                                        value: item.id,
                                        label: item.academic_year
                                    }))}
                                    placeholderName={'Year'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                    isClearable={false}
                                />
                                <span className="text-danger f-16">{this.state.examError}</span>
                            </Col>

                            {/* No Branch picker — the header (NavbarOne) scopes this page. */}

                            <Col lg={2} md={12} sm={12}>
                                <div style={styles.label}><i className="fas fa-graduation-cap" style={styles.labelIcon} />Class</div>
                                <SelectDropDown
                                    stateData={this.state.classSearchval}
                                    handleChange={this.selecthandleInputChange}
                                    name="classSearch"
                                    options={this.state.getClasses}
                                    placeholderName={'Class'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                    isClearable={false}
                                />
                                {/* <span className="text-danger f-16">{this.state.classError}</span> */}
                            </Col>

                            {isStreamClass(this.state.classSearchval?.value) && (
                                <Col lg={2} md={12} sm={12}>
                                    <div style={styles.label}><i className="fas fa-stream" style={styles.labelIcon} />Stream</div>
                                    <SelectDropDown
                                        stateData={this.state.streamSearchval}
                                        handleChange={this.selecthandleInputChange}
                                        name="streamSearch"
                                        options={this.state.getStreams}
                                        placeholderName={'Stream'}
                                        dropdownIndicator={{ DropdownIndicator }}
                                        isClearable={false}
                                    />
                                </Col>
                            )}

                            <Col lg={2} md={12} sm={12}>
                                <div style={styles.label}><i className="fas fa-layer-group" style={styles.labelIcon} />Section</div>
                                <SelectDropDown
                                    stateData={this.state.sectionSearchval}
                                    handleChange={this.selecthandleInputChange}
                                    name="sectionSearch"
                                    options={this.state.getSections}
                                    placeholderName={'Section'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                    isClearable={false}
                                />
                                {/* <span className="text-danger f-16">{this.state.sectionError}</span> */}
                            </Col>

                            <Col lg={2} md={12} sm={12}>
                                <div style={styles.label}><i className="far fa-calendar-check" style={styles.labelIcon} />Attendance Type</div>
                                <SelectDropDown
                                    stateData={this.state.attendanceSearchval}
                                    handleChange={this.selecthandleInputChange}
                                    name="attendanceType"
                                    options={this.state.attendance_types}
                                    placeholderName={'Attendance Type'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                    isClearable={false}
                                />
                                {/* <span className="text-danger f-16">{this.state.attendanceError}</span> */}
                            </Col>

                            <Col lg={2} md={12} sm={12} className="d-flex align-items-end mt-4">
                                <button
                                    style={styles.addBtn}
                                    onClick={this.handleFormSubmit}
                                >
                                    Get Students
                                </button>
                            </Col>
                        </Row>


                        {
                            this.state.getEducationalStudents.length > 0 ?
                                (
                                    <>
                                        <div style={{
                                            background: "#f8fafc",
                                            border: "1px solid #e2e8f0",
                                            borderRadius: "12px",
                                            padding: "14px 20px",
                                            marginBottom: "16px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            flexWrap: "wrap",
                                            gap: "16px",
                                            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05)"
                                        }}>
                                            <div style={{ display: "flex", gap: "24px", alignItems: "center", flexWrap: "wrap" }}>
                                                <span style={{ fontSize: "14px", color: "#475569" }}>
                                                    <strong>Total Students:</strong> <span style={{ color: "#4f46e5", fontWeight: "700", marginLeft: "4px" }}>{this.state.getEducationalStudents.length}</span>
                                                </span>
                                                <span style={{ fontSize: "14px", color: "#475569" }}>
                                                    <strong>Present:</strong> <span style={{ color: "#16a34a", fontWeight: "700", marginLeft: "4px" }}>{this.state.no_of_present}</span>
                                                </span>
                                                <span style={{ fontSize: "14px", color: "#475569" }}>
                                                    <strong>Absent:</strong> <span style={{ color: "#dc2626", fontWeight: "700", marginLeft: "4px" }}>{this.state.no_of_absent}</span>
                                                </span>
                                                <span style={{ fontSize: "13px", color: "#64748b", marginLeft: "8px" }}>
                                                    <i className="fa fa-info-circle mr-1" /> All students are marked present by default.
                                                </span>
                                                <label style={{ 
                                                    display: "inline-flex", 
                                                    alignItems: "center", 
                                                    gap: "8px", 
                                                    margin: "0 0 0 16px", 
                                                    cursor: "pointer", 
                                                    fontSize: "13.5px", 
                                                    color: "#4f46e5", 
                                                    fontWeight: "700",
                                                    background: "#eff6ff",
                                                    padding: "4px 10px",
                                                    borderRadius: "8px",
                                                    border: "1px solid #bfdbfe",
                                                    userSelect: "none"
                                                }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={!!this.state.filterAbsenteesOnly}
                                                        onChange={(e) => this.setState({ filterAbsenteesOnly: e.target.checked })}
                                                        style={{ cursor: "pointer", width: "15px", height: "15px" }}
                                                    />
                                                    <span>Show Biometric Absentees Only ({this.state.getEducationalStudents.filter(item => parseInt(item.attendance_status) === 0).length})</span>
                                                </label>
                                            </div>
                                            <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                                                <Button
                                                    onClick={() => this.submitPresentAndAbsentAttendance("present")}
                                                    disabled={this.state.presentAttendanceLoader}
                                                    style={{
                                                        background: "linear-gradient(135deg, #16a34a, #22c55e)",
                                                        border: "none",
                                                        borderRadius: "8px",
                                                        padding: "7px 14px",
                                                        fontWeight: "600",
                                                        fontSize: "13px",
                                                        color: "#fff",
                                                        boxShadow: "0 2px 4px rgba(22,163,74,0.15)"
                                                    }}
                                                >
                                                    {this.state.presentAttendanceLoader ? (
                                                        <span className="spinner-border spinner-border-sm" />
                                                    ) : (
                                                        <>
                                                            <i className="fa fa-check-circle mr-1" /> ALL PRESENT
                                                        </>
                                                    )}
                                                </Button>
                                                <Button
                                                    onClick={() => this.submitPresentAndAbsentAttendance("absent")}
                                                    disabled={this.state.presentAttendanceLoader}
                                                    style={{
                                                        background: "#dc2626",
                                                        border: "none",
                                                        borderRadius: "8px",
                                                        padding: "7px 14px",
                                                        fontWeight: "600",
                                                        fontSize: "13px",
                                                        color: "#fff",
                                                        boxShadow: "0 2px 4px rgba(220,38,38,0.15)"
                                                    }}
                                                >
                                                    {this.state.presentAttendanceLoader ? (
                                                        <span className="spinner-border spinner-border-sm" />
                                                    ) : (
                                                        <>
                                                            <i className="fa fa-times-circle mr-1" /> ALL ABSENT
                                                        </>
                                                    )}
                                                </Button>
                                            </div>
                                        </div>

                                        <Row className="mt-1">
                                            <Col sm={12}>
                                                <div
                                                    style={{
                                                        background: "#ffffff",
                                                        borderRadius: "18px",
                                                        padding: "18px",
                                                        boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
                                                    }}
                                                >
                                                    {(() => {
                                                        const filteredData = this.state.filterAbsenteesOnly
                                                            ? this.state.getEducationalStudents.filter(item => parseInt(item.attendance_status) === 0)
                                                            : this.state.getEducationalStudents;
                                                        return (
                                                            <CardLessDataTable
                                                                parentData={filteredData}
                                                                particlecolumns={columns}
                                                            />
                                                        );
                                                    })()}

                                                    {/* Submit Button Row */}
                                                    <Row className="mt-4 align-items-center">
                                                        <Col
                                                            md={12}
                                                            sm={12}
                                                            className="d-flex justify-content-end"
                                                        >
                                                            <Button
                                                                onClick={this.openSubmitAttendanceModal}
                                                                style={{
                                                                    background: "linear-gradient(135deg, #4f46e5, #6366f1)",
                                                                    border: "none",
                                                                    borderRadius: "12px",
                                                                    padding: "12px 24px",
                                                                    fontWeight: "700",
                                                                    fontSize: "14px",
                                                                    boxShadow: "0 6px 16px rgba(99,102,241,0.35)",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px"
                                                                }}
                                                            >
                                                                <i className="fa fa-check-circle"></i>
                                                                Submit Attendance
                                                            </Button>
                                                        </Col>
                                                    </Row>

                                                </div>
                                            </Col>
                                        </Row>

                                    </>
                                ) : (
                                    <Row>
                                        <Col sm={12}>
                                            {this.state.loader == 1 ? (
                                                <div className="py-4">
                                                    <style>
                                                        {`
                                                            @keyframes shimmerLoading {
                                                                0% { background-position: -1000px 0; }
                                                                100% { background-position: 1000px 0; }
                                                            }
                                                            .shimmer-line {
                                                                height: 20px;
                                                                margin-bottom: 15px;
                                                                background: #f6f7f8;
                                                                background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
                                                                background-repeat: no-repeat;
                                                                background-size: 1000px 100%;
                                                                animation: shimmerLoading 1.5s infinite linear forwards;
                                                                border-radius: 4px;
                                                            }
                                                            .shimmer-header { height: 40px; margin-bottom: 24px; border-radius: 8px; }
                                                        `}
                                                    </style>
                                                    <div className="shimmer-line shimmer-header" style={{ width: '100%' }}></div>
                                                    <div className="shimmer-line" style={{ width: '100%' }}></div>
                                                    <div className="shimmer-line" style={{ width: '100%' }}></div>
                                                    <div className="shimmer-line" style={{ width: '100%' }}></div>
                                                    <div className="shimmer-line" style={{ width: '100%' }}></div>
                                                    <div className="shimmer-line" style={{ width: '80%' }}></div>
                                                </div>
                                            ) : (
                                                <div style={{ color: "#9ca3af" }}>
                                                    {this.state.submitted == true && this.state.loader == 0 && this.state.getEducationalStudents.length == 0 ? (
                                                        <h6 className="d-flex justify-content-center align-items-center mt-5">No students available</h6>
                                                    ) : null}
                                                </div>
                                            )}
                                        </Col >
                                    </Row>
                                )
                        }
                    </div>
                </div>


                {/* <AddStudentModal
                    stateData={this.state}
                    globals={globals.globals}
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                /> */}

                <SubmitAttendanceModal
                    stateData={this.state}
                    show={this.state.modalShow1}
                    onHide={() => this.setState({ modalShow1: false })}
                    onsubmit={() => this.submit()}
                    clearAttendanceData={() => this.clearAttendanceData()}
                />

                <HolidayModal
                    show={this.state.holidayModal}
                    onHide={() => this.setState({
                        holidayModal: false, holidayBranchError: "", holidayBranch: "",
                        holidayBranchVal: "",
                        holidayBranchError: "",
                        submitted: false
                    })}
                    markHoliday={this.markHoliday}
                    stateData={this.state}
                    globals={this.props.branches}
                    selecthandleInputChange={this.selecthandleInputChange}
                />

                <AttendanceNotificationModal
                    show={this.state.notifyModal}
                    onHide={() => this.setState({
                        notifyModal: false, submitted: false
                    })}
                    stateData={this.state}
                    onsubmit={() => this.submit()}
                />

                {/* Shown instead of submitting attendance / marking a holiday / sending
                    absentee notifications when is_edit is missing. One modal serves every
                    intercepted action. This module has no delete surface. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />

            </div>
        );
    }
}


export default withRouter(withApollo(
    compose(
        graphql(ADD_HOLIDAY, {
            name: "addHolidays"
        }),
        graphql(ADD_ATTENDANCE, {
            name: "addAttendance"
        })
    )(StudentAttendanceHome))
);
